import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Topbar from '../PulseSurvey/Topbar';
import Loader from '../../component/common/Loader';
import { Api } from '../../api';
import { errorToast, successToast } from '../../utils/helper';
import Icons from '../../component/svgs/icons';
import toast from 'react-hot-toast';
import { PER_PAGE } from '../../utils/constants';
import ViewEnrolledUsersModal from '../SuperAdminSalarySacrifice/ViewEnrolledUsersModal';
import AddCompanyModal from './AddCompanyModal';
import AddUsersModal from './AddUsersModal';
import { StatCard, STAT_ICONS, TableCard} from '../../component/common/designSystem';
import Table from '../../component/common/Table';
import moment from 'moment';
import Pagination from '../../component/common/Pagination/Pagination';
import ConfirmPopup from '../../component/common/modals/ConfirmPopup';
import SearchInput from '../../component/common/Input/SearchInput';

const STATUS_FILTER = [
  { value: null, name: 'All' },
  { value: true, name: 'Active' },
  { value: false, name: 'Inactive' }
];
const AdminHealthSchemes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [healthSchemesList, setHealthSchemesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage] = useState(10);
  const [searchKey, setSearchKey] = useState('');
  const [loader, setLoader] = useState(true);
  const [showAddUsersModal, setShowAddUsersModal] = useState(false);
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [totalActiveCompanies, setTotalActiveCompanies] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalShoorahCount, setTotalShoorahCount] = useState(0);
  const [totalCustomCount, setTotalCustomCount] = useState(0);
  const [totalEnrolledUsers, setTotalEnrolledUsers] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(STATUS_FILTER[0]);

  const [showViewUsersModal, setShowViewUsersModal] = useState(false);
  const [selectedCompanyForUsers, setSelectedCompanyForUsers] = useState(null);
  const [showAddDropdown, setShowAddDropdown] = useState(false);
  const [editSchemeData, setEditSchemeData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  // const fetchHealthSchemes = async (page = 1, search = '') => {
  //   setLoading(true);
  //   try {
  //     const response = await Api.getHealthSchemesList(page, perPage, search);
  //     if (response?.data?.meta?.code === 1) {
  //       setHealthSchemesList(response?.data?.data || []);
  //       setTotalRecords(response?.data?.meta?.totalRecords || 0);
  //       setCurrentPage(page);
  //     } else {
  //       errorToast(response?.data?.meta?.message || 'Failed to fetch health schemes');
  //     }
  //   } catch (error) {
  //     console.error('Failed to fetch health schemes:', error);
  //     errorToast('Failed to fetch health schemes');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchHealthSchemes(1, searchKey);
  // }, []);
  const columns = (handleEdit, handleView, handleDelete) => [
    {
      title: 'Company Name',
      key: 'companyName',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 200
    },
    {
      title: 'Provider Name',
      key: 'providerName',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 150
    },
    {
      title: 'Start Date',
      key: 'startDate',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 120
    },
    {
      title: 'End Date',
      key: 'endDate',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 120
    },

    {
      title: 'Scheme Type',
      key: 'schemeType',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 120
    },
    {
      title: 'Status',
      key: 'status',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 120
    },
    {
      title: 'Total Enrolled Users',
      key: 'totalEnrolledUsers',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 150
    },
    {
      title: 'Action',
      key: 'action',
      type: 'action',
      align: 'right',
      isView: true,
      isEdit: true,
      isDelete: true,
      width: 100,
      handleEdit: handleEdit,
      handleView: handleView,
      handleDelete: handleDelete
    }
  ];
  useEffect(() => {
    fetchCompanies(currentPage, selectedPerPage.value, searchTerm, selectedStatus.value);
  }, [currentPage, selectedPerPage, selectedStatus]);

  // Debounced search with reset to page 1
  useEffect(() => {
    if (searchTerm !== undefined) {
      const delayDebounceFn = setTimeout(() => {
        setCurrentPage(1);
        fetchCompanies(1, selectedPerPage.value, searchTerm, selectedStatus.value);
      }, 800);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchTerm]);

  const fetchCompanies = async (page, limit, search, isActive) => {
    setLoader(true);
    try {
      const response = await Api.getCompaniesWithHealthScheme(page, limit, search, isActive);

      if (response?.data?.meta?.code === 1) {
        const companiesData = response?.data?.data || [];
        console.log(companiesData);
        setCompanies(companiesData);
        setTotalCount(response?.data?.meta?.totalCompany || 0);
        setTotalShoorahCount(response?.data?.meta?.shoorahProvidedCount || 0);
        setTotalCustomCount(response?.data?.meta?.customPlanCount || 0);
        setTotalRecords(response?.data?.meta?.totalRecords || 0);
        setCurrentPage(page);

        // Calculate stats
        const activeCount = companiesData.filter((c) => c.isActive).length;
        const totalUsers = companiesData.reduce((sum, c) => sum + (c.totalEnrolledUsers || 0), 0);
        setTotalActiveCompanies(activeCount);
        setTotalEnrolledUsers(totalUsers);
      } else {
        errorToast(response?.data?.message || 'Failed to fetch companies');
        setCompanies([]);
        setTotalCount(0);
        setTotalActiveCompanies(0);
        setTotalEnrolledUsers(0);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
      errorToast('Failed to fetch companies');
      setCompanies([]);
      setTotalCount(0);
      setTotalActiveCompanies(0);
      setTotalEnrolledUsers(0);
    } finally {
      setLoader(false);
    }
  };
  const handleAddUsers = () => {
    setShowAddUsersModal(true);
  };

  const handleAddCompany = () => {
    setShowAddDropdown(false);
    setShowAddCompanyModal(true);
  };

  const handleAddCustom = () => {
    setShowAddDropdown(false);
    navigate('/health-scheme/create');
  };

  const toggleAddDropdown = () => {
    setShowAddDropdown((prev) => !prev);
  };

  const refreshTable = () => {
    fetchCompanies(currentPage, selectedPerPage.value, searchTerm, selectedStatus.value);
  };
  const handleUsersAdded = () => {
    setShowAddUsersModal(false);
    refreshTable();
    successToast('Users added successfully');
  };
  const handleCompanyAdded = () => {
    setShowAddCompanyModal(false);
    refreshTable();
    successToast('Company added successfully');
  };
  const handleSearch = (e) => {
    e.preventDefault();
    fetchCompanies(1, searchKey);
  };

  const handleToggleVisibility = async (id, currentVisibility) => {
    setLoading(true);
    try {
      const response = await Api.toggleHealthSchemeVisibility({
        id,
        isSchemeVisible: !currentVisibility
      });

      if (response?.data?.meta?.code === 1) {
        toast.success('Visibility updated successfully');
        fetchCompanies(currentPage, searchKey);
      } else {
        errorToast(response?.data?.meta?.message || 'Failed to update visibility');
      }
    } catch (error) {
      console.error('Failed to toggle visibility:', error);
      errorToast('Failed to update visibility');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 2 : 1; // Toggle between Active and Inactive
    setLoading(true);
    try {
      const response = await Api.updateHealthSchemeStatus({
        id,
        status: newStatus
      });

      if (response?.data?.meta?.code === 1) {
        toast.success('Status updated successfully');
        fetchCompanies(currentPage, searchKey);
      } else {
        errorToast(response?.data?.meta?.message || 'Failed to update status');
      }
    } catch (error) {
      console.error('Failed to toggle status:', error);
      errorToast('Failed to update status');
    } finally {
      setLoading(false);
    }
  };

  // const handleDelete = async (id) => {
  //   if (!window.confirm('Are you sure you want to delete this health scheme?')) {
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await Api.deleteHealthScheme({ id });

  //     if (response?.data?.meta?.code === 1) {
  //       toast.success('Health scheme deleted successfully');
  //       fetchCompanies(currentPage, searchKey);
  //     } else {
  //       errorToast(response?.data?.meta?.message || 'Failed to delete health scheme');
  //     }
  //   } catch (error) {
  //     console.error('Failed to delete health scheme:', error);
  //     errorToast('Failed to delete health scheme');
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    setCurrentPage(1);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  // Action handlers for table
  const handleEdit = (rowData) => {
    const fullCompanyData = companies.find((c) => c.companyId === rowData.companyID);
    console.log(rowData, fullCompanyData);
    if (fullCompanyData?.schemeType == 2) {
      navigate(`/health-scheme/create?id=${fullCompanyData.companyId}&isEdit=true`);
      return;
    }
    setEditSchemeData({
      companyId: rowData.companyID,
      companyName: rowData.companyName,
      ...fullCompanyData
    });
    setIsEditMode(true);
    setShowAddCompanyModal(true);
  };

  const handleView = (rowData) => {
    const fullCompanyData = companies.find((c) => c._id === rowData.companyID);
    if (fullCompanyData?.schemeType == 2) {
      navigate(`/health-scheme/create?id=${fullCompanyData.companyId}&isEdit=true`);
      return;
    }
    setEditSchemeData({
      companyId: rowData.companyID,
      companyName: rowData.companyName,
      ...fullCompanyData
    });
    setIsEditMode(false);
    setShowAddCompanyModal(true);
  };

  const handleDelete = (rowData) => {
    console.log(rowData);
    setCompanyToDelete(rowData);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (!companyToDelete) return;

    setIsDeleting(true);
    try {
      const response = await Api.deleteHealthScheme(companyToDelete.schemeId);

      if (response?.data?.meta?.code === 1) {
        successToast('Health scheme deleted successfully');
        setShowDeleteConfirm(false);
        setCompanyToDelete(null);
        refreshTable();
      } else {
        errorToast(response?.data?.meta?.message || 'Failed to delete scheme');
      }
    } catch (error) {
      console.error('Error deleting scheme:', error);
      errorToast('Failed to delete scheme');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setCompanyToDelete(null);
  };
  // Transform data for table display
  const rowsData = companies.map((company) => {
    const statusClassName = company.isActive
      ? 'bg-green-100 text-green-800'
      : 'bg-gray-100 text-gray-800';

    return {
      id: company._id,
      companyID: company.companyId,
      schemeId: company.schemeId,
      schemeType: company.schemeType,
      isCustomPlan: company.isCustomPlan,
      companyName: (
        <div className="flex items-center gap-2">
          <span>
            {company.companyName
              ? company.companyName
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ')
              : ''}
          </span>
        </div>
      ),
      providerName: <div className="text-sm">{company.providerName || 'Shoorah'}</div>,
      startDate: (
        <div className="text-sm">
          {company.startDate ? moment(company.startDate).format('MMM DD, YYYY') : '-'}
        </div>
      ),
      endDate: (
        <div className="text-sm">
          {company.expiryDate ? moment(company.expiryDate).format('MMM DD, YYYY') : '-'}
        </div>
      ),
      status: (
        <div
          className={`w-24 h-6 flex items-center justify-center text-center text-xs rounded-full border ${statusClassName}`}
        >
          {company.isActive ? 'Active' : 'Inactive'}
        </div>
      ),
      schemeType: <div className="text-sm">{company.schemeType == 2 ? 'Custom' : 'Shoorah'}</div>,
      totalEnrolledUsers: <div className="text-sm">{company.totalEnrolledUsers || 0}</div>
    };
  });
  const totalPages = Math.ceil(totalRecords / perPage);
  // Dashboard info cards
  const dashboardCards = [
    <StatCard
      icon={STAT_ICONS.company}
      title={'Total Companies'}
      value={totalShoorahCount + totalCustomCount}
    />,
    <StatCard
      icon={STAT_ICONS.catalog}
      title={'Total Active Shoorah'}
      value={totalShoorahCount}
    />,
    <StatCard
      icon={STAT_ICONS.custom}
      title={'Total Active Custom'}
      value={totalCustomCount}
    />
  ];
  return (
    <div className="relative lg:mb-[45px]">
      {loading && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Health Schemes Management - Shoorah Admin</title>
      </Helmet>
      <Topbar
        title="Health Schemes Management"
        hasDesc={true}
        description="View and manage all health schemes across companies"
        infoBtn={false}
      />

      <div className="mt-9">
        {/* Search and Add Button */}
        <div className="sm:flex flex-col md:flex-row mt-5 justify-between items-center gap-3">
          {/* Left-aligned search input */}
          <div className="flex items-center gap-3 w-full sm:w-auto">
            {/* <div className="w-[180px]">
              <SelectMenu
                menuList={STATUS_FILTER}
                showLabel={false}
                defaultSelected={selectedStatus}
                setSelectedMenu={setSelectedStatus}
              />
            </div> */}

            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search companies..."
              className="w-full sm:w-auto px-3 py-2"
              value={searchTerm}
            />
          </div>

          {/* Right-aligned buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div className="self-center inline-flex items-center justify-center w-64 sm:w-auto">
              <button
                className="inline-flex text-xs sm:text-base font-medium items-center justify-center rounded-3xl border bg-blue-500 px-5 py-2 text-white shadow-sm hover:bg-blue-600 focus:outline-none w-full sm:w-auto"
                onClick={handleAddUsers}
              >
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 4.45825V15.5416"
                    stroke="white"
                    strokeWidth="1.58333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3.95801 10H15.0413"
                    stroke="white"
                    strokeWidth="1.58333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Add Users
              </button>
            </div>

            <div className="self-center relative inline-flex items-center justify-center w-64 sm:w-auto">
              <button
                className="btn-primary btn-sm w-full sm:w-auto"
                onClick={toggleAddDropdown}
              >
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 4.45825V15.5416"
                    stroke="white"
                    strokeWidth="1.58333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3.95801 10H15.0413"
                    stroke="white"
                    strokeWidth="1.58333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Add Company
                <svg
                  className={`w-4 h-4 transition-transform ${showAddDropdown ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Dropdown Menu */}
              {showAddDropdown && (
                <>
                  {/* Backdrop to close dropdown when clicking outside */}
                  <div className="fixed inset-0 z-10" onClick={() => setShowAddDropdown(false)} />

                  {/* Dropdown Content */}
                  <div className="absolute top-full right-0 mt-2 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-600 z-20 overflow-hidden">
                    <div className="py-2">
                      {/* Add to Health Scheme Option */}
                      <button
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors flex items-center gap-3 group"
                        onClick={handleAddCompany}
                      >
                        <div className="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center group-hover:bg-blue-200 dark:group-hover:bg-blue-800 transition-colors">
                          <svg
                            className="w-5 h-5 text-blue-600 dark:text-blue-300"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                          </svg>
                        </div>
                        <div className="flex-1">
                          <div className="text-sm font-semibold text-gray-900 dark:text-white">
                            Add to Health Scheme
                          </div>
                          <div className="text-xs text-gray-500 dark:text-gray-400">
                            Add existing company to scheme
                          </div>
                        </div>
                      </button>

                      {/* Divider */}
                      <div className="border-t border-gray-100 dark:border-shoorah-darkBorder my-1" />

                      {/* Create Custom Option */}
                      <button
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors flex items-center gap-3 group"
                        onClick={handleAddCustom}
                      >
                        <div className="flex-shrink-0 w-10 h-10 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center group-hover:bg-purple-200 dark:group-hover:bg-purple-800 transition-colors">
                          <svg
                            className="w-5 h-5 text-purple-600 dark:text-purple-300"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                          </svg>
                        </div>
                        <div className="flex-1">
                          <div className="text-sm font-semibold text-gray-900 dark:text-white">
                            Create Custom Scheme
                          </div>
                          <div className="text-xs text-gray-500 dark:text-gray-400">
                            Create new health scheme
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {dashboardCards.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>

        <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalRecords,
            pageSize: selectedPerPage?.value,
            onPageChange: handlePagination,
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
            columns={columns(handleEdit, handleView, handleDelete)}
            data={rowsData}
            name={'salary_sacrifice_companies_table'}
            bottomBorder={totalRecords > selectedPerPage?.value}
            refreshTable={refreshTable}
            loader={loader}
          />
        </TableCard>

        

        {/* Modals */}
        {showAddCompanyModal && (
          <AddCompanyModal
            isOpen={showAddCompanyModal}
            onClose={() => {
              setShowAddCompanyModal(false);
              setEditSchemeData(null);
              setIsEditMode(false);
            }}
            onSuccess={handleCompanyAdded}
            editData={editSchemeData}
            isEditMode={isEditMode}
          />
        )}

        {showAddUsersModal && (
          <AddUsersModal
            isOpen={showAddUsersModal}
            onClose={() => setShowAddUsersModal(false)}
            onSuccess={handleUsersAdded}
          />
        )}

        {showViewUsersModal && selectedCompanyForUsers && (
          <ViewEnrolledUsersModal
            isOpen={showViewUsersModal}
            onClose={() => {
              setShowViewUsersModal(false);
              setSelectedCompanyForUsers(null);
            }}
            company={selectedCompanyForUsers}
            onToggleUser={refreshTable}
          />
        )}
        {/* Health Schemes Table */}
        {/* <div className="bg-white dark:bg-shoorah-darkBgTabColor rounded-xl shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-shoorah-darkBgColor">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Scheme Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Company
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Health Cash Plans
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Occupational Plans
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Visible
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-shoorah-darkBgTabColor divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                {healthSchemesList.length > 0 ? (
                  healthSchemesList.map((scheme) => (
                    <tr key={scheme._id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {scheme.schemeName}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500 dark:text-gray-300">
                          {scheme.companyName || 'N/A'}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500 dark:text-gray-300">
                          {scheme.totalHealthCashPlans || 0}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500 dark:text-gray-300">
                          {scheme.totalOccupationalPlans || 0}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          onClick={() => handleToggleStatus(scheme._id, scheme.status)}
                          className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            scheme.status === 1
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {scheme.status === 1 ? 'Active' : 'Inactive'}
                        </button>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          onClick={() => handleToggleVisibility(scheme._id, scheme.isSchemeVisible)}
                          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                            scheme.isSchemeVisible ? 'bg-shoorah-primary' : 'bg-gray-200'
                          }`}
                        >
                          <span
                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                              scheme.isSchemeVisible ? 'translate-x-6' : 'translate-x-1'
                            }`}
                          />
                        </button>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() =>
                              navigate(`/health-scheme/add-edit?type=admin&id=${scheme._id}`)
                            }
                            className="text-shoorah-primary hover:text-shoorah-secondary"
                            title="Edit"
                          >
                            <Icons.edit className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() => handleDelete(scheme._id)}
                            className="text-red-600 hover:text-red-800"
                            title="Delete"
                          >
                            <Icons.trash className="w-5 h-5" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="px-6 py-4 text-center text-gray-500 dark:text-gray-300"
                    >
                      No health schemes found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

         
        </div> */}
      </div>

      {/* Delete Confirmation Popup */}
      <ConfirmPopup
        open={showDeleteConfirm}
        setOpen={setShowDeleteConfirm}
        setAccepted={confirmDelete}
        handleNo={handleDeleteCancel}
        message="Are you sure you want to remove this company from Health Scheme? This action cannot be undone."
        isLoading={isDeleting}
      />
    </div>
  );
};

export default AdminHealthSchemes;
